var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComputeError({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BA5560FD-29FB-4B45-8312-8757329F6976") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons",
    transform: "translate(-56.000000, -925.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ERROR",
    transform: "translate(19.000000, 825.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/16x16/Compute/Paused-Copy-3",
    transform: "translate(37.000000, 100.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-box",
    x: 0,
    y: 0,
    width: 36,
    height: 36
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Triangle",
    fill: "#DB3214",
    points: "17.71875 2.375 34.875 30.5 0.5625 30.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.958289,32.6176376 C35.2596525,32.6176376 36.7061054,30.13645 35.5538081,28.1515241 L20.5748571,2.34106569 C19.4240839,0.358805615 16.5365429,0.355170441 15.3836969,2.34106569 L0.404319136,28.1515241 C-0.745722507,30.1326936 0.694085247,32.6176376 2.99989923,32.6176376 L32.958289,32.6176376 Z M32.3135243,29.6396429 L3.64502968,29.6396429 C3.35684865,29.6396429 3.17657548,29.3296232 3.32063551,29.081462 L17.6548219,4.38978885 C17.7990038,4.1415065 18.1595502,4.1415065 18.3037321,4.38978885 L32.6379185,29.0814015 C32.7820395,29.3295626 32.6018273,29.6396429 32.3135243,29.6396429 Z M19.2705133,21.2022236 C19.6690408,21.2022236 19.9952639,20.8917798 20.0183696,20.5014834 L20.4296387,13.5529705 C20.4549392,13.1252924 20.1128042,12.7647437 19.6818434,12.7647437 L16.2765277,12.7647437 C15.8456278,12.7647437 15.5034929,13.1252924 15.5287933,13.5529705 L15.9400625,20.5014834 C15.963351,20.8949909 16.2912812,21.2022236 16.6879187,21.2022236 L19.2705133,21.2022236 Z M17.979277,27.2821724 C19.427376,27.2821724 20.6012549,26.1155846 20.6012549,24.6764801 C20.6012549,23.2373755 19.427376,22.0707877 17.979277,22.0707877 C16.531178,22.0707877 15.3572991,23.2373755 15.3572991,24.6764801 C15.3572991,26.1155846 16.531178,27.2821724 17.979277,27.2821724 Z",
    id: "\\uF071",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputeError);
export default __webpack_public_path__ + "static/media/compute-error.c42e97fe8eec709d2757b9397d565186.svg";
export { ForwardRef as ReactComponent };